import { useEffect, useState } from 'react'
import FooterPartenerCommun from '../commun/FooterPartenerCommun'
import Header from '../commun/Header'

export default function Program_DRF(){

    const dates = [
        'Thursday 14',
        'Friday 15',
    ];

    const [day, setDay] = useState(0);

    const program = [
        [
            {
                hours: '17:00 – 19:30',
                program: { 
                    title: 'Madrid: Global Hub of Technology and Entrepreneurship',
                    description: 'Venue: InvestMadrid Office, Calle O’Donnell 12, 8th Floor, 28009 Madrid',
                    others: [
                        new Other('PART I (17h00 – 18h00): ', `<strong>Luis Socías</strong>, Managing Director, InvestMadrid Office 
                                    <strong>Agustina Angelino</strong>, Head of Cabinet of the Regional Minister for Economy, Finance and Employment, Madrid region
                                    <strong>Jaime Martínez</strong>, Director General for Economic and Industrial Promotion, of the Region of Madrid`),
                        new Other('PART II (18h00 – 19h00): ', `<strong>Javier Torremocha</strong>, Founder and Managing Partner of Kibo Ventures VC 
                                    <strong>Miguel Arias</strong>, Founder and Managing Partner of K-Fund VC
                                    <strong>Sergio Álvarez Teleña</strong>, Founder and CEO of SciTheWorld, fmr. BBVA Global Head of Data Science`),
                        new Other('PART III (19h00 – 19h45):', `Cocktail reception at InvestMadrid rooftop with panelists and participants`),
                    ],
                }
            },
            {
                hours: '19:45',
                program: { 
                    title: '<span style="font-weight: normal">Bus departs towards Rosewood Villa Magna Hotel.</span>',
                    description: '',
                }
            }
            ,
            {
                hours: '21:00 – 23:30',
                program: { 
                    title: 'DRFs Dinner',
                    description: 'Restaurante Sagardi, Paseo de la Castellana 13, Madrid 28046',
                }
            }
        ],
        [
            {
                hours: '09:45 – 11:45',
                program: {
                    title: `Visit to the National Parliament: Congreso de los Diputados:`,
                    description: `Bus arrives Rosewood Villa Magna Hotel at 9h00am for a timely departure at 9h15am.<br/> Welcome by <strong>Mr. Alberto Fabra</strong>, MP Chairman of the Parliamentary Committee for Defense Presentation and Q&A with the MP Chairmen of the Parliamentary Committees for Economics (<strong>Mr. Pedro Puy Fraga, MP</strong>) and Defense (<strong>Mr. Alberto Fabra, MP</strong>). <br/>Bus picks group up at 11h45 and drives to IE University`,
                }
            },{
                hours: '12:15 – 15:00',
                program: {
                    title: `IE University: Instituto de Empresa`,
                    description: `12h15: Arrival at IE University Campus
                                    <br/>
                                    12h15 – 12h45: Visit tour of IE Campus
                                    <br/>
                                    12h45 – 13h45: Foresight of future US-EU relations after the US Presidential elections:
                                    <br/>
                                    <strong>Amanda Sloat</strong>, former Special Assistant to the President and Senior Director for Europe, U.S. National Security Council
                                    Moderator: <strong>Jacobo Roa Vicens</strong>, DRF
                                    <br/>
                                    13h45 – 14h45: buffet lunch with IE leadership, and address to DRFs by <strong>Dr. Manuel Muñiz</strong>, Provost of IE University in Madrid, Dean of IE School of Politics, Economics & Global Affairs, fmr. State Secretary for Global Spain
                                    <br/>
                                    15h00 – Bus departs from IE University towards Rosewood Villa Magna Hotel`,
                }
            }
        ]
    ];

    return(
        <div className="dashboard">
            <Header back={true}></Header>
            <h2 className='mt-4 text-center'>
                Program
            </h2>
            <div className='grid-display mt-3'>
                <div className='grid-program-2'>
                {
                    dates.map((date, index)=>{
                        return(
                            <div key={index} className={"p-1 bg-light"} onClick={()=>{setDay(index)}}>
                                <div className={(index === day) ? 'card-date-active' : 'card-date'}>
                                    {date}
                                </div>
                            </div>
                        );
                        })
                    }
                </div>
            </div>
            <div className='container'>
                {
                    program[day].map((prog, index)=>{
                        const hours = prog.hours.split(' – ');
                        return(
                            <div key={index} className={(index % 2) ? 'p-1 program bg-l' : 'mt-3 program bg-d'}>
                                <div className='text-center p-2'>
                                    <h6 className='start-h'>
                                        {hours[0]}
                                    </h6>
                                    <h6 className='end-h'>
                                        {hours[1]}
                                    </h6>
                                </div>
                                <div className='p-2'>
                                    <span style={{fontWeight: 'bold', fontSize: '1.4em'}} dangerouslySetInnerHTML={{__html:prog.program.title}}></span>
                                    <br />                                    
                                    {
                                        (prog.program.description && prog.program.description.length) ?
                                        <div>
                                            <br />
                                            <span dangerouslySetInnerHTML={{__html: prog.program.description}}>
                                        </span>   
                                        </div>
                                        :
                                        ''
                                    }
                                    <br />
                                    {(prog.program.moderators && prog.program.moderators.length) ? <><br /><span style={{fontWeight: 'bold', fontSize: '1.2em'}}>Moderator:</span><br /></> : ''}
                                    
                                    {
                                        prog.program.moderators && prog.program.moderators.map((mod)=>{
                                            return(
                                                <div>
                                                    <span style={{fontWeight: 'bold'}}>{mod.full_name}: </span>
                                                    <span dangerouslySetInnerHTML={{__html: mod.description}}></span>
                                                    <br />
                                                    <br />
                                                </div>
                                            );
                                        })
                                    }
                                    {
                                        prog.program.mores ?
                                        prog.program.mores.map((more)=>{
                                            return (
                                            <div>
                                                <span style={{fontWeight: 'bold'}}>{more.title}</span>
                                                <span dangerouslySetInnerHTML={{__html:more.description}}></span>
                                                <br />
                                                <br />
                                            </div>)
                                        })
                                        :
                                        ''
                                    }
                                    {(prog.program.speakers && prog.program.speakers.length) ? <><span style={{fontWeight: 'bold', fontSize: '1.2em'}}>{(prog.program.speakers.length > 1) ? 'Speakers:' : 'Speaker:'}</span><br /></> : ''}
                                    {
                                        prog.program.speakers && prog.program.speakers.map((speaker)=>{
                                            return(
                                                <div>
                                                    <span style={{fontWeight: 'bold'}}>{speaker.full_name}: </span>
                                                    <span>{speaker.description}</span>
                                                    <br />
                                                    <br />
                                                </div>
                                            );
                                        })
                                    }
                                    {
                                        prog.program.others ?
                                        prog.program.others.map((other)=>{
                                            return (
                                            <div>
                                                <span style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{__html: other.title}}></span>
                                                <span dangerouslySetInnerHTML={{__html:other.description}}></span>
                                                <br />
                                                <br />
                                            </div>)
                                        })
                                        :
                                        ''
                                    }
                                </div>
                            </div>
                        );
                    })
                }
            </div>
            <FooterPartenerCommun/>
        </div>
    )
}

class Speaker{
    constructor(full_name, description){
        this.full_name = full_name;
        this.description = description;
    }
}

class Moderator{
    constructor(full_name, description){
        this.full_name = full_name;
        this.description = description;
    }
}

class Other {
    constructor(title, description){
        this.title = title;
        this.description = description;
    }
}